import { UserData } from '@/types/user';
import { EntityState } from '@reduxjs/toolkit';

export const extractUserData = (userData: EntityState<UserData> | undefined): UserData | undefined => {
  if (!userData) {
    return;
  }
  const id = userData.ids[0];
  return userData.entities?.[id];
};
